import kael from "./kael.jpg";
import nic from "./nic.jpg";
import ronnie from "./ronnie.jpg";
import jocko from "./jocko.jpg";
import khabib from "./khabib.jpg";
import stipe from "./stipe.jpg";
import amaia from "./amaia.jpg";
import soviets from "./soviets.jpg";
import palmerston from "./palmerston.jpg";
import gulls from "./gulls.jpg";
import chemist from "./chemist.jpg";
import interstellar from "./interstellar.jpg";
import oberyn from "./oberyn.jpg";
import ubereem from "./ubereem.jpg";
import leo from "./leo.jpg";
import arny from "./arny.jpg";
import ras from "./ras.jpg";
import die from "./die.jpg";
import stannis from "./stannis.jpg";
//To Do: integrate images into database

const Imgs = [
  nic,
  khabib,
  jocko,
  stipe,
  ronnie,
  nic,
  amaia,
  soviets,
  palmerston,
  gulls,
  chemist,
  interstellar,
  kael,
  oberyn,
  ubereem,
  leo,
  arny,
  ras,
  die,
  stannis,
];
export default Imgs;
